import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1560bd1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-bespoke-infection-routes" }
const _hoisted_2 = { class: "hd-bespoke-infection-routes__top" }
const _hoisted_3 = { class: "hd-bespoke-infection-routes__toggle" }
const _hoisted_4 = { class: "hd-bespoke-infection-routes__slider-labels" }
const _hoisted_5 = { class: "hd-bespoke-infection-routes__button" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("i")
const _hoisted_7 = { class: "hd-bespoke-infection-routes__container" }
const _hoisted_8 = { class: "hd-bespoke-infection-routes__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!
  const _component_base_toggle = _resolveComponent("base-toggle")!
  const _component_slider = _resolveComponent("slider")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_versions_dynamic_view = _resolveComponent("versions-dynamic-view")!
  const _component_base_image_svg = _resolveComponent("base-image-svg")!
  const _component_overlay_module = _resolveComponent("overlay-module")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_lyra_asset, {
      class: "hd-title",
      "asset-key": `${_ctx.endpointId}.title`
    }, null, 8, ["asset-key"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_base_toggle, {
          items: _ctx.toggleItems,
          onToggleUpdated: _ctx.updateToggleActive
        }, null, 8, ["items", "onToggleUpdated"])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["hd-bespoke-infection-routes__slider", `hd-bespoke-infection-routes__slider--${_ctx.toggleActive}`])
      }, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.severity, (item) => {
            return (_openBlock(), _createBlock(_component_lyra_asset, {
              key: item,
              class: _normalizeClass(`hd-bespoke-infection-routes__slider-label hd-bespoke-infection-routes__slider-label--${item}`),
              "asset-key": `${_ctx.endpointId}.${_ctx.toggleActive}.slider.${item}.label`
            }, null, 8, ["class", "asset-key"]))
          }), 128))
        ]),
        _createVNode(_component_slider, {
          modelValue: _ctx.severityActive,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.severityActive) = $event)),
          tooltips: false,
          max: 2,
          lazy: false,
          step: -1
        }, null, 8, ["modelValue"])
      ], 2),
      _createVNode(_component_versions_dynamic_view, null, {
        fmd: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_base_button, {
              callback: _ctx.processOverlay,
              callbackString: "info",
              shape: "circular",
              class: "crux-click",
              "data-crux": "page-overlay"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["callback"])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass(["hd-bespoke-infection-routes__boxes", `hd-bespoke-infection-routes__boxes--${_ctx.toggleActive}`])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boxesLeft, (box) => {
          return (_openBlock(), _createElementBlock("div", {
            key: box,
            class: _normalizeClass(["hd-bespoke-infection-routes__box", [
                        `hd-bespoke-infection-routes__box--${_ctx.checkSeverity(box)}`,
                        `hd-bespoke-infection-routes__box--${_ctx.severityActiveConvert(_ctx.severityActive)}`
                    ]])
          }, [
            _createVNode(_component_lyra_asset, {
              "asset-key": `${_ctx.endpointId}.${_ctx.toggleActive}.${box}.text`
            }, null, 8, ["asset-key"])
          ], 2))
        }), 128))
      ], 2),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_base_image_svg, {
          source: require('@/applications/covid-hub/ui/assets/bespoke/body-elements.png'),
          "is-image": true
        }, null, 8, ["source"])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["hd-bespoke-infection-routes__boxes", `hd-bespoke-infection-routes__boxes--${_ctx.toggleActive}`])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.boxesRight, (box) => {
          return (_openBlock(), _createElementBlock("div", {
            key: box,
            class: _normalizeClass(["hd-bespoke-infection-routes__box", [
                        `hd-bespoke-infection-routes__box--${_ctx.checkSeverity(box)}`,
                        `hd-bespoke-infection-routes__box--${_ctx.severityActiveConvert(_ctx.severityActive)}`
                    ]])
          }, [
            _createVNode(_component_lyra_asset, {
              "asset-key": `${_ctx.endpointId}.${_ctx.toggleActive}.${box}.text`
            }, null, 8, ["asset-key"])
          ], 2))
        }), 128))
      ], 2)
    ]),
    _createVNode(_component_versions_dynamic_view, null, {
      fmd: _withCtx(() => [
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            (_ctx.overlay === 'info')
              ? (_openBlock(), _createBlock(_component_overlay_module, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_lyra_asset, {
                      "asset-key": `${_ctx.endpointId}.${_ctx.toggleActive}.popup-text`
                    }, null, 8, ["asset-key"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      galaxy: _withCtx(() => [
        _createVNode(_component_lyra_asset, {
          "asset-key": `${_ctx.endpointId}.${_ctx.toggleActive}.popup-text`
        }, null, 8, ["asset-key"])
      ]),
      _: 1
    })
  ]))
}